import React from "react";
import dynamic from 'next/dynamic';
import {Card} from "antd";
import style from "./chartSupport.module.scss";
import {useTranslations} from "next-intl";

const Column = dynamic(() => import('@ant-design/plots').then(({ Column }) => Column),
    { ssr: false }
);

export const SupportChart = ({info}) => {
    const t = useTranslations('dashboard');
    const config = {
        data: info ?? [],
        xField: 'date',
        yField: 'value',
        stack: true,
        colorField: 'type',
        scale: { color: { range: ['#9E3636', '#D7CBCB', '#DD8080'] } },
        height: 365,
    };

    return (
        <>
            <div className={style.block}>
                <Card
                    title={t('ticket_statistic')}
                    className={'charts'}
                >
                    <Column {...config} />
                </Card>
            </div>
        </>
    );
}